import { useEffect, useMemo, useState } from "react";
import { MagnifyingGlass, Buildings, UserCircle } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function FlatDirectory() {
  const [items, setItems] = useState([]);
  const [wing, setWing] = useState("ALL");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/api/flats").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);

  const filtered = useMemo(() => {
    return items.filter((f) => (wing === "ALL" || f.wing === wing) && (!q || f.label.toLowerCase().includes(q.toLowerCase()) || f.residents?.some((r) => r.name.toLowerCase().includes(q.toLowerCase()))));
  }, [items, wing, q]);

  return (
    <div className="space-y-4 font-sans" data-testid="flat-directory-screen">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-[0.32em] text-white/50">Society</p>
        <h1 className="font-display text-3xl font-extrabold text-white">Flat Directory</h1>
      </div>

      <div className="flex items-stretch gap-2 overflow-hidden rounded-2xl border border-white/15 bg-white/[0.03] focus-within:border-neon-cyan">
        <span className="flex items-center px-3 text-white/55"><MagnifyingGlass size={18} weight="bold" /></span>
        <input className="flex-1 bg-transparent px-2 py-3 text-sm text-white outline-none placeholder:text-white/30" placeholder="Search flat or resident…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="flat-search" />
      </div>

      <div className="flex gap-2">
        {["ALL", "C", "D"].map((w) => (
          <button key={w} onClick={() => setWing(w)} data-testid={`wing-${w}`} className={`rounded-full border px-3 py-1.5 text-[12px] font-bold uppercase tracking-wider ${wing === w ? "border-neon-cyan/60 bg-neon-cyan/15 text-neon-cyan" : "border-white/10 bg-white/5 text-white/70"}`}>
            {w === "ALL" ? "All" : `${w} Wing`}
          </button>
        ))}
        <span className="ml-auto self-center text-[11px] text-white/45">{filtered.length} flats</span>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {filtered.slice(0, 120).map((f) => (
          <div key={f.id} className="card p-4" data-testid={`flat-${f.id}`}>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-neon-cyan/15 text-neon-cyan"><Buildings size={18} weight="duotone" /></div>
              <div className="min-w-0 flex-1">
                <p className="font-mono text-[15px] font-bold text-white">{f.label}</p>
                <p className="text-[11px] text-white/55">Floor {f.floor} · Unit {f.number}</p>
              </div>
              <span className="chip">{f.residents?.length || 0} <UserCircle size={12} weight="fill" className="ml-0.5" /></span>
            </div>
            {f.residents?.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1.5">
                {f.residents.map((r) => (
                  <span key={r.id} className="chip">{r.name} · {r.role}</span>
                ))}
              </div>
            )}
          </div>
        ))}
        {filtered.length > 80 && <p className="text-center text-[12px] text-white/45">Showing first 80 results. Refine your search to see more.</p>}
      </div>
    </div>
  );
}
